module.exports = __webpack_public_path__ + "img/designs-717.0950459.png";